module.exports = __webpack_public_path__ + "img/Group744.53e84967.svg";